import { push } from 'react-router-redux';

import {
  NOT_CORRECT_EXAM_FORM_SHOW,
  NOT_CORRECT_EXAM_FORM_CHANGE,
  NOT_CORRECT_EXAM_FORM_SET_INVALID,
  NOT_CORRECT_EXAM_FORM_SUBMIT,
  NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR,
  NOT_CORRECT_EXAM_FORM_SUBMIT_SUCCESS,
  REQUEST_APPEAL_SUCCESS,
  REQUEST_APPEAL_ALREADY_REPORTED
} from '../constants';
import { NOT_CORRECT_EXAM_FROM } from '../../constants/validationFromName';
import { APPLICANT_TYPES } from '../../constants/applicant';

import { formNotCorrectExamSelector } from '../notCorrectExam/selectors';
import { applicantTypeSelector } from '../applicant/selectors';
import {
  notCorrectExamStructuredParentSelector,
  notCorrectExamStructuredSelector
} from '../notCorrectExam/submitDataSelector';

import validation from '../../services/validation';
import { fetchPOST } from '../../resources/fetchHelper';
import apiRoutes from '../../resources/apiRoutes';
import {
  sendCMAAppealBusinessError,
  sendCMANotCorrectBusinessError,
  sendCMANotCorrectFinish,
  sendCMANotCorrectStart,
  sendCMANotCorrectTechError
} from '../../helpers/CMAStats';
import { deleteDraft } from '../draft/actions';
import { appealSubmitParticipantSelector } from '../gia/selectors';
import { currentExamSelector, examIdSelector } from '../examData/selectors';
import { snilsValidate } from '../../services/validationRules';
import { getFindAppeal } from '../../resources';
import { getUserSnilsSelector } from '../mainData/selectors';

const notCorrectExamFormShowMiddleware = () => next => action => {
  if (action.type !== NOT_CORRECT_EXAM_FORM_SHOW) {
    return next(action);
  }

  sendCMANotCorrectStart();

  return next(action);
};

const notCorrectExamFormChangeMiddleware = ({
  getState,
  dispatch
}) => next => action => {
  if (action.type !== NOT_CORRECT_EXAM_FORM_CHANGE) {
    return next(action);
  }

  const {
    payload: { blur }
  } = action;

  if (blur) {
    const state = getState();
    const formData = formNotCorrectExamSelector(state);
    const validationForm = validation(formData, NOT_CORRECT_EXAM_FROM);

    dispatch(deleteDraft());

    return dispatch({
      type: NOT_CORRECT_EXAM_FORM_SET_INVALID,
      payload: validationForm
    });
  }

  return next(action);
};

const submitNotCorrectExamMiddleware = ({
  getState,
  dispatch
}) => next => action => {
  if (action.type !== NOT_CORRECT_EXAM_FORM_SUBMIT) {
    return next(action);
  }

  const state = getState();
  const applicantType = applicantTypeSelector(state);

  let submitData;

  if (applicantType === APPLICANT_TYPES.parent) {
    submitData = notCorrectExamStructuredParentSelector(state);
  } else {
    submitData = notCorrectExamStructuredSelector(state);
  }

  const formData = formNotCorrectExamSelector(state);
  const validationForm = validation(formData, NOT_CORRECT_EXAM_FROM);

  const { registration_code } = appealSubmitParticipantSelector(state);
  const examId = examIdSelector(state);
  const snils = getUserSnilsSelector(state);

  const { type, subject_code, date } = currentExamSelector({
    ...state,
    examData: {
      ...state.examData,
      examId
    }
  });

  if (validationForm.valid) {
    const onError = error => {
      sendCMANotCorrectTechError({ stage: 'final' });
      dispatch({ type: NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR, error });
    };

    if (snils && snils.match(snilsValidate.pattern)) {
      getFindAppeal({
        snils,
        exam_type: type,
        subject_code,
        reg_code: registration_code,
        exam_date: date
      })
        .then(response => {
          if (response.code === 'SUCCESS' || response.code === 'OK') {
            return new Promise((resolve, reject) => {
              if (response.data.application === false) {
                return resolve();
              } else {
                return reject(REQUEST_APPEAL_ALREADY_REPORTED);
              }
            });
          }
          return response;
        })
        .then(() => {
          return fetchPOST(apiRoutes.getNotCorrectExamUrl(), submitData);
        })
        .then(response => {
          if (response.code === 'SUCCESS' || response.code === 'OK') {
            dispatch({
              type: NOT_CORRECT_EXAM_FORM_SUBMIT_SUCCESS,
              payload: response
            });

            dispatch({
              type: REQUEST_APPEAL_SUCCESS,
              payload: {
                ...response,
                action: 'denial'
              }
            });

            sendCMANotCorrectFinish();
            dispatch(push('/success-denial/'));
            dispatch(deleteDraft());
          } else if (response.code === 'ALREADY_REPORTED') {
            sendCMAAppealBusinessError({ stage: 'final' });
            dispatch({
              type: REQUEST_APPEAL_ALREADY_REPORTED,
              payload: 'denial'
            });
          } else {
            onError(response.message);
          }
          return response;
        })
        .catch(error => {
          if (REQUEST_APPEAL_ALREADY_REPORTED) {
            dispatch({
              type: error,
              payload: 'denial'
            });
            return;
          }
          onError();
        });
    }
  } else {
    sendCMANotCorrectBusinessError({ stage: 'final' });

    return dispatch({
      type: NOT_CORRECT_EXAM_FORM_SET_INVALID,
      payload: validationForm
    });
  }

  return next(action);
};

const notCorrectExamMiddleware = [
  notCorrectExamFormChangeMiddleware,
  submitNotCorrectExamMiddleware,
  notCorrectExamFormShowMiddleware
];

export default notCorrectExamMiddleware;
